import React from "react";
import { Modal, List } from "antd";

const ResultImportModal = ({ visible, onClose, resultImport }) => {
  return (
    <Modal
      title="Result Import"
      open={visible}
      onOk={onClose}
      onCancel={onClose}
      okText="Close"
      cancelButtonProps={{ style: { display: "none" } }} // Ẩn nút Cancel
    >
      <List
        size="small"
        bordered
        dataSource={resultImport}
        renderItem={(item, index) => (
          <List.Item>
            {index + 1}. {item}
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ResultImportModal;
